import { makeReturningUserTracker } from './make-returning-user-tracker';
import { SocketIOEventClient } from './socket-io-event-client';
import { timeMeInstrumentationService } from './timeme-instrumentation-service';
import { routeMap } from './route-map';
const trackReturningUserEvent = makeReturningUserTracker(routeMap, new SocketIOEventClient(), timeMeInstrumentationService);
export { trackReturningUserEvent, makeReturningUserTracker };
//# sourceMappingURL=index.js.map